import { render, staticRenderFns } from "./softwareMobile.vue?vue&type=template&id=9a6c31b0&scoped=true"
import script from "./softwareMobile.vue?vue&type=script&lang=js"
export * from "./softwareMobile.vue?vue&type=script&lang=js"
import style0 from "./softwareMobile.vue?vue&type=style&index=0&id=9a6c31b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6c31b0",
  null
  
)

export default component.exports